import React, { useEffect } from 'react';
import { Switch, Route, useRouteMatch, useLocation } from 'react-router-dom';
import FormBuilderList from './FormBuilderList';
import FormBuilderEditor from './FormBuilderEditor';
import FormBuilderCreate from './FormBuilderCreate';
import FormPreview from './FormPreview';

const FormBuilder = () => {
	const { path } = useRouteMatch();
	const location = useLocation();

	console.log('FormBuilder component mounted. Path:', path);
	console.log('Current location:', location.pathname);

	useEffect(() => {
		console.log('FormBuilder paths - base path:', path);
		console.log('FormBuilder paths - current location:', location.pathname);
	}, [path, location]);

	return (
		<div>
			<Switch>
				<Route exact path='/admin/form-builder'>
					{console.log('Rendering FormBuilderList route')}
					<FormBuilderList />
				</Route>
				<Route exact path='/admin/form-builder/create'>
					{console.log('Rendering FormBuilderCreate route')}
					<FormBuilderCreate />
				</Route>
				<Route path='/admin/form-builder/edit/:id'>
					{console.log('Rendering FormBuilderEditor edit route')}
					<FormBuilderEditor />
				</Route>
				<Route path='/admin/form-builder/view/:id'>
					{console.log('Rendering FormPreview view route')}
					<FormPreview />
				</Route>
			</Switch>
		</div>
	);
};

export default FormBuilder;
